import React, { useState } from "react";
import { Avatar, Box, Button, Typography, Modal } from "@mui/material";
import SettingsIcon from "@mui/icons-material/Settings";
import EditName from "./EditName";
import ChangePassword from "./ChangePassword";
import * as Style from "./style";

const EditProfile = () => {
  const [showSettings, setShowSettings] = useState(false);
  const [openEditNameModal, setOpenEditNameModal] = useState(false);
  const [openChangePasswordModal, setOpenChangePasswordModal] = useState(false);

  const toggleSettings = () => setShowSettings(!showSettings);

  const handleOpenEditName = () => setOpenEditNameModal(true);
  const handleCloseEditName = () => setOpenEditNameModal(false);

  const handleOpenChangePassword = () => setOpenChangePasswordModal(true);
  const handleCloseChangePassword = () => setOpenChangePasswordModal(false);

  return (
    <Style.Userdetail>
      <Box className="main-box">
        <Box className="inside-box">
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            flexWrap="wrap"
          >
            <Avatar alt="Profile Picture">KK</Avatar>
            <Box>
              <Typography variant="h5" color="primary" fontWeight="bold" mt={3}>
                Kartik Katwal
              </Typography>
            </Box>
            <Box>
              <Typography variant="h6" color="primary" fontWeight="bold" mt={1}>
                kartik.katwal@webmoninfo.ch
              </Typography>
            </Box>
          </Box>
        </Box>
        <Box onClick={toggleSettings} className="settings-box">
          <Typography variant="h6" color="primary" textAlign="left">
            SETTINGS
          </Typography>
          <SettingsIcon color="primary" />
        </Box>
        {showSettings && (
          <Box className="inner-settings-box">
            <Style.ButtonProfile>
              <Button
                variant="contained"
                color="primary"
                fullWidth
                onClick={handleOpenChangePassword}
              >
                Change Password
              </Button>
            </Style.ButtonProfile>
            <Style.ButtonProfile>
              <Button
                variant="contained"
                color="primary"
                fullWidth
                onClick={handleOpenEditName}
              >
                Edit Name
              </Button>
            </Style.ButtonProfile>
          </Box>
        )}
      </Box>

      <Modal open={openEditNameModal} onClose={handleCloseEditName}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 500,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            borderRadius: 2,
          }}
        >
          <EditName />
        </Box>
      </Modal>
      <Modal open={openChangePasswordModal} onClose={handleCloseChangePassword}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 500,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            borderRadius: 2,
          }}
        >
          <ChangePassword />
        </Box>
      </Modal>
    </Style.Userdetail>
  );
};

export default EditProfile;
